import { EventEmitter } from 'events';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { CHANGE_EVENT } from '../constants/AppConstants';
import {
  CLEAR_DISPUTE_FORM_DATA,
  DISPLAY_REVIEW_SCREEN,
  HANDLE_SUBMIT_DISPUTE_CASE_FAILURE,
  HANDLE_SUBMIT_DISPUTE_CASE_SUCCESS,
  RESET_REFUND_DETAILS,
  SET_DISPUTE_JOURNEY_TYPE,
  SET_EXPECTED_SERVICE_START_DATE,
  SET_EXPECTED_TRAVEL_DEPARTURE_DATE,
  SET_EXPECTED_TRAVEL_RETURN_DATE,
  SET_GOODS_DESCRIPTION_TEXT,
  SET_GOODS_EXPECTED_DELIVERY_DATE,
  SET_PARTIAL_REFUND_AMOUNT,
  SET_REFUND_TYPE,
  SET_SELLER_CONTACT_DATE,
  SET_SELLER_CONTACT_DESCRIPTION_TEXT,
  SET_SERVICE_DESCRIPTION_TEXT,
  SET_TRAVEL_DESCRIPTION_TEXT,
  SUBMIT_DISPUTE_CASE,
} from '../constants/FraudAndDisputeConstants';
import FraudAndDisputeApiUtils from '../utils/FraudAndDisputeApiUtils';

let isDisputeCaseCreated,
  submitDisputeCaseErrorMessage,
  submitDisputeCasestatusResponse,
  displayReviewScreen = false,
  refundType = '',
  partialRefundAmount = '',
  disputeJourneyType = '',
  goodsExpectedDeliveryDate = null,
  goodsDescriptionText = '',
  sellerContactDate = null,
  sellerDescriptionText = '',
  expectedTravelDepartureDate = null,
  expectedTravelReturnDate = null,
  travelDescriptionText = '',
  expectedServiceStartDate = null,
  serviceDescriptionText = '';

class FraudAndDisputeStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getIsDisputeCaseCreated() {
    return isDisputeCaseCreated;
  }
  getSubmitDisputeCaseErrorMessage() {
    return submitDisputeCaseErrorMessage;
  }
  getSubmitDisputeCaseStatusResponse() {
    return submitDisputeCasestatusResponse;
  }
  getRefundType() {
    return refundType;
  }
  getPartialRefundAmount() {
    return partialRefundAmount;
  }
  getDisputeJourneyType() {
    return disputeJourneyType;
  }
  getGoodsExptectedDeliveryDate() {
    return goodsExpectedDeliveryDate;
  }
  getGoodsDescriptionText() {
    return goodsDescriptionText;
  }
  getSellerContactDate() {
    return sellerContactDate;
  }
  getSellerContactDescriptionText() {
    return sellerDescriptionText;
  }
  getExpectedTravelDepartureDate() {
    return expectedTravelDepartureDate;
  }
  getExpectedTravelReturnDate() {
    return expectedTravelReturnDate;
  }
  getTravelDescriptionText() {
    return travelDescriptionText;
  }
  getShouldDisplayReviewScreen() {
    return displayReviewScreen;
  }
  getExptectedServiceStartDate() {
    return expectedServiceStartDate;
  }
  getServiceDescriptionText() {
    return serviceDescriptionText;
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case SUBMIT_DISPUTE_CASE:
        FraudAndDisputeApiUtils.submitDisputeCase(actionData.caseDetails);
        break;
      case HANDLE_SUBMIT_DISPUTE_CASE_SUCCESS:
        isDisputeCaseCreated = true;
        this.emitChange();
        break;
      case HANDLE_SUBMIT_DISPUTE_CASE_FAILURE:
        submitDisputeCaseErrorMessage = actionData.errorMessage;
        submitDisputeCasestatusResponse = actionData.statusCode;
        isDisputeCaseCreated = false;
        this.emitChange();
        break;
      case SET_REFUND_TYPE:
        refundType = actionData.type;
        break;
      case SET_PARTIAL_REFUND_AMOUNT:
        partialRefundAmount = actionData.amount;
        break;
      case SET_DISPUTE_JOURNEY_TYPE:
        disputeJourneyType = actionData.journeyType;
        break;
      case SET_GOODS_EXPECTED_DELIVERY_DATE:
        goodsExpectedDeliveryDate = actionData.expectedDeliveryDate;
        break;
      case SET_GOODS_DESCRIPTION_TEXT:
        goodsDescriptionText = actionData.descriptionText;
        break;
      case SET_SELLER_CONTACT_DATE:
        sellerContactDate = actionData.sellerContactDate;
        this.emitChange();
        break;
      case SET_SELLER_CONTACT_DESCRIPTION_TEXT:
        sellerDescriptionText = actionData.descriptionText;
        this.emitChange();
        break;
      case SET_EXPECTED_TRAVEL_DEPARTURE_DATE:
        expectedTravelDepartureDate = actionData.expectedDepartureDate;
        this.emitChange();
        break;
      case SET_EXPECTED_TRAVEL_RETURN_DATE:
        expectedTravelReturnDate = actionData.expectedReturnDate;
        break;
      case SET_TRAVEL_DESCRIPTION_TEXT:
        travelDescriptionText = actionData.descriptionText;
        break;
      case DISPLAY_REVIEW_SCREEN:
        displayReviewScreen = actionData.shouldDisplayReviewScreen;
        this.emitChange();
        break;
      case SET_EXPECTED_SERVICE_START_DATE:
        expectedServiceStartDate = actionData.expectedStartDate;
        break;
      case SET_SERVICE_DESCRIPTION_TEXT:
        serviceDescriptionText = actionData.descriptionText;
        break;
      case CLEAR_DISPUTE_FORM_DATA:
        disputeJourneyType = '';
        goodsExpectedDeliveryDate = null;
        goodsDescriptionText = '';
        sellerContactDate = null;
        sellerDescriptionText = '';
        expectedTravelDepartureDate = null;
        expectedTravelReturnDate = null;
        travelDescriptionText = '';
        displayReviewScreen = false;
        expectedServiceStartDate = null;
        serviceDescriptionText = '';
        isDisputeCaseCreated = false;
        this.emitChange();
        break;
      case RESET_REFUND_DETAILS:
        refundType = '';
        partialRefundAmount = '';
        this.emitChange();
        break;

      default: {
        break;
      }
    }
  }
}
export default new FraudAndDisputeStore();
